<div class="h-13 px-5 flex items-center border-b bg-white">
  <!-- LOGO APP -->
  <div class="flex-1 flex items-center gap-2">
    <i *ngIf="isSmallScreen" class="pi pi-bars p-1 cursor-pointer hover:text-blue-500" (click)="setSidebar()"></i>
    <!-- Default Logo -->
    <a *ngIf="!isQa" class="flex items-center gap-2">
      <div class="h-9 flex items-center justify-start pl-[2px]">
        <img class="h-9 w-9" src="/assets/images/chicilon_media_logo_01.png" alt="logo" />
      </div>
      <h1 class="font-semibold text-base">Chicilon Media</h1>
    </a>

    <!-- QA Logo -->
    <a *ngIf="isQa" class="flex items-center gap-2">
      <div class="h-9 flex items-center justify-start pl-[2px]">
        <img class="h-9 w-9" src="/assets/images/tma-logo.png" alt="logo" />
      </div>
      <h1 class="font-semibold text-base">TMA Solutions</h1>
    </a>
  </div>

  <!-- RIGHT ITEM -->
  <div class="flex-1 flex gap-1 justify-end">
    <div class="flex items-center gap-1">
      <!-- NOTIFICATION -->
      <app-notification></app-notification>

      <!-- <app-flags #flags></app-flags> -->

      <div>
        <div
          class="flex items-center cursor-pointer gap-1 py-[2px] pl-2 rounded-sm hover:bg-gray-200"
          (click)="visible = !visible">
          @if(user$ | async; as user) {
          <app-custom-avatar size="sm" [imgId]="user?.image_url" [name]="user?.full_name || ''"></app-custom-avatar>
          }
          <i class="icon-wl-arrow-drop-down text-4"></i>
        </div>
        <p-overlay [(visible)]="visible" appendTo="body">
          <div class="border px-1 py-2 bg-white w-[240px] rounded-sm mr-5">
            <!-- INFO -->
            @if(user$ | async; as user) {
            <div class="border-b flex items-center p-2 gap-2">
              <app-custom-avatar size="sm" [imgId]="user?.image_url" [name]="user?.full_name || ''"></app-custom-avatar>
              <div class="flex flex-col gap-0.5">
                <span class="font-semibold">{{ user?.username }}({{ user?.chinese_name }})</span>
                <div class="text-gray-600 text-2">
                  {{ user?.job_position ? (translatePrefix + 'JOB_POSITION.' + user.job_position | translate) : '' }}
                </div>
              </div>
            </div>
            }

            <div class="border-b py-2">
              <a
                [routerLink]="'settings/account-setting'"
                class="flex gap-2 items-center h-9 px-2 cursor-pointer hover:bg-neutral-100 rounded-sm"
                (click)="visible = false">
                <i class="icon-wl-user text-6"></i>
                <span>{{ translatePrefix + 'SETTINGS.ACCOUNT-SETTINGS' | translate }}</span>
              </a>
              <a
                class="flex gap-2 items-center h-9 px-2 cursor-pointer hover:bg-neutral-100 rounded-sm"
                (click)="onChangePassword()">
                <i class="icon-wl-key text-6"></i>
                <span>{{ translatePrefix + 'USER-ACTION.CHANGE-PASSWORD' | translate }}</span>
              </a>
            </div>

            <div
              (click)="onSignOut()"
              class="mt-2 px-2 h-9 text-red-600 flex items-center gap-2 cursor-pointer hover:bg-gray-100 rounded-sm">
              <i class="icon-wl-log-out text-6"></i>
              <span>{{ translatePrefix + 'SIGN_UP.SIGN_OUT' | translate }}</span>
            </div>
          </div>
        </p-overlay>
      </div>
    </div>
  </div>
</div>
@if (isChangePassword) {
<app-change-password-dialog [(isChangePassword)]="isChangePassword"></app-change-password-dialog>
}
